import '../../style.scss';
import { DistanceHelper } from '../../../../../../../../../../helpers/distance.helper';
import { IMicromobilityLink } from '../../../../../../../../../../models/labs/micromobility/micromobility-link.model';
import { ITripLeg } from '../../../../../../../../../../models/trip-leg.model';
import { TranslationService } from '../../../../../../../../../../services/translation.service';
import MicromobilityTransportTrip from '../../../../../../../../../Shared/JourneySearchResults/MicromobilityTransportTrip';
import MicromobilityHelper from '../../../../../../../../helpers/micromobility.helper';
import LineMarker from '../../../LineMarker';
import { CircleDisplayType, LineDistance, LineType } from '../../../LineMarker/line-markers.enum';
import EstimatedAndPlannedTimes from '../../../shared/EstimatedAndPlannedTimes';
import { AnalyticsService } from '../../../../../../../../../../services/analytics-service';

function MicromobilityCalls({
  micromobilityLink,
  journeyId,
  firstTripLegOnJourney,
  onClose,
  onUpdateAvailableVehicles,
}: {
  micromobilityLink: IMicromobilityLink;
  journeyId: number;
  firstTripLegOnJourney: ITripLeg | undefined;
  onClose: () => void;
  onUpdateAvailableVehicles: () => void;
}) {
  return (
    <div className="trip-leg-calls position-relative">
      <div className="d-flex justify-content-between border-bottom mb-2 pb-1">
        <div className="d-flex align-items-center">
          <MicromobilityTransportTrip className="" micromobilityLink={micromobilityLink} showWithVehicleCount={false} />
          <span className="align-self-center flex-grow-1">
            {MicromobilityHelper.getVehicleTypeName(micromobilityLink)} {DistanceHelper.format(micromobilityLink.distanceInMeters)}
          </span>
        </div>
        <button type="button" className="d-none d-md-block btn-close trip-leg-calls__btn-close d-print-none" aria-label={TranslationService.get('common.close')} onClick={onClose}></button>
        <button
          type="button"
          className="d-md-none btn-close trip-leg-calls__btn-close d-print-none"
          aria-label={TranslationService.get('common.close')}
          onClick={onClose}
          aria-controls={`journey-details-map-${journeyId}`}
          aria-expanded="true"
        ></button>
      </div>
      <ol className="list-unstyled">
        <li className="d-flex overflow-hidden print-no-break">
          <LineMarker
            foregroundColor="#00394D"
            backgroundColor="#fff"
            lineColor="#00394D"
            lineType={LineType.solid}
            circleDisplayType={CircleDisplayType.center}
            lineDistance={LineDistance.halfEnd}
            className="flex-shrink-0 trip-leg-calls__line-marker"
          />
          <div className="flex-grow-1 ms-2 py-2 border-bottom">
            <EstimatedAndPlannedTimes estimatedTime={undefined} plannedTime={micromobilityLink.plannedDepartureTime} isCancelled={false} />
            <div className="d-flex justify-content-between">
              <div className="fw-bold">{micromobilityLink.originStation?.name ?? TranslationService.get('travelplanner.micromobility.defaultfromstation')}</div>
            </div>
          </div>
        </li>
        <li className="d-flex overflow-hidden print-no-break">
          <LineMarker
            foregroundColor="#00394D"
            backgroundColor="#fff"
            lineColor="#00394D"
            lineType={LineType.solid}
            circleDisplayType={CircleDisplayType.center}
            lineDistance={LineDistance.halfStart}
            className="flex-shrink-0 trip-leg-calls__line-marker"
          />
          <div className="flex-grow-1 ms-2 py-2">
            <EstimatedAndPlannedTimes estimatedTime={undefined} plannedTime={micromobilityLink.plannedArrivalTime} isCancelled={false} />
            <div className="d-flex justify-content-between">
              <div className="fw-bold">
                {micromobilityLink.destinationStation?.name ?? MicromobilityHelper.getEndDestinationNameForMicromobilityDocklessLink(micromobilityLink, true, firstTripLegOnJourney)}
              </div>
            </div>
          </div>
        </li>
      </ol>
      <button
        className="btn--as-link micromobility-leg__update-availability"
        onClick={() => {
          onUpdateAvailableVehicles();
          AnalyticsService.addEvent(AnalyticsService.LabsMicromobility, 'Uppdatera tillgänglighet för hyrcykel i mikrodelresan', micromobilityLink.vehicle?.operatorName ?? '');
        }}
      >
        {TranslationService.get('travelplanner.micromobility.updateavailability')}
      </button>
    </div>
  );
}

export default MicromobilityCalls;
